/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Representation of a request of replacing an existing user's password
 * @export
 * @interface ReplacePasswordInput
 */
export interface ReplacePasswordInput {
    /**
     * Current password of the customer.
     * @type {string}
     * @memberof ReplacePasswordInput
     */
    oldPassword: string;
    /**
     * New password of the customer.
     * @type {string}
     * @memberof ReplacePasswordInput
     */
    newPassword: string;
}

/**
 * Check if a given object implements the ReplacePasswordInput interface.
 */
export function instanceOfReplacePasswordInput(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "oldPassword" in value;
    isInstance = isInstance && "newPassword" in value;

    return isInstance;
}

export function ReplacePasswordInputFromJSON(json: any): ReplacePasswordInput {
    return ReplacePasswordInputFromJSONTyped(json, false);
}

export function ReplacePasswordInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReplacePasswordInput {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'oldPassword': json['oldPassword'],
        'newPassword': json['newPassword'],
    };
}

export function ReplacePasswordInputToJSON(value?: ReplacePasswordInput | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'oldPassword': value.oldPassword,
        'newPassword': value.newPassword,
    };
}

